import { Button } from 'grommet'
import styled from 'styled-components'

const PrimaryButton = styled(Button)`
  background: #f4f4df;
  color: #666510;
`

export default PrimaryButton